<template>
    <div class="programme container-md my-5">
        <h1 class="section-title py-2">Programme</h1>

        <div class="row">
            <div class="col-12 col-md">
                <h3 class="text-primary mt-5"><i class="fa-solid fa-calendar-days mr-3"></i> <span>Mardi 7 février 2023</span></h3>
                <table class="table table-unbordered av85" id="programme-table">
                    <tr class="border-bottom border-bottom-lg border-primary">
                        <td class="time">08h30 :</td>
                        <td>Accueil des participants</td>
                    </tr>
                    <tr>
                        <td class="time">09h00 :</td>
                        <td>Mot de bienvenue du Directeur du Lycée</td>
                    </tr>
                    <tr>
                        <td class="time">09h05 :</td>
                        <td>Le Permis Tronçonneuse en France, en Europe & démonstration</td>
                    </tr>
                    <tr>
                        <td class="time">09h15 :</td>
                        <td>Démonstration de la préparation d'une formation</td>
                    </tr>
                    <tr class="border-bottom border-bottom-lg border-primary">
                        <td class="time">11h15 :</td>
                        <td>Pause café</td>
                    </tr>
                    <tr>
                        <td class="time">11h45 :</td>
                        <td>Réponses aux questions posées, échanges</td>
                    </tr>
                    <tr class="border-bottom border-bottom-lg border-primary">
                        <td class="time">13h00 :</td>
                        <td>Déjeuner sur place</td>
                    </tr>
                    <tr>
                        <td class="time">14h00 :</td>
                        <td>La "Place du marché"</td>
                    </tr>
                    <tr>
                        <td class="time">15h15 :</td>
                        <td>Synthèse de la "Place du marché"</td>
                    </tr>
                    <tr>
                        <td class="time">16h00 à 18h00 :</td>
                        <td>Le Permis Tronçonneuse dans un centre accrédité & exposition d'outils innovants</td>
                    </tr>
                    <tr>
                        <td class="time">18h30 :</td>
                        <td>Opération surprise</td>
                    </tr>
                    <tr>
                        <td class="time">19h30 :</td>
                        <td>Dîner</td>
                    </tr>
                </table>
                <div class="d-flex-center">
                    <button type="button" @click="openPdf7" class="btn btn-pill btn-outline-primary av85 d-flex align-items-center mb-4">
                        <i class="fa-solid fa-file-pdf mr-3 fa-2x"></i>
                        <div class="d-flex flex-column justify-content-center">
                            <span>Consulter le programme détaillé</span>
                            <span class="fs-sm">(Mardi 07 février)</span>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col-12 col-md d-flex flex-column">
                <h3 class="text-primary mt-5"><i class="fa-solid fa-calendar-days mr-3"></i> <span>Mercredi 8 février 2023</span></h3>
                <table class="table table-unbordered av85" id="programme-table">
                    <tr class="border-bottom border-bottom-lg border-primary">
                        <td class="time">08h30 :</td>
                        <td>Accueil des participants</td>
                    </tr>
                    <tr>
                        <td class="time">09h00 :</td>
                        <td>Mot de bienvenue du Directeur du Lycée</td>
                    </tr>
                    <tr>
                        <td class="time">09h20 :</td>
                        <td>Démonstration en extérieur de l'évaluation de candidats au Permis Tronçonneuse ECC1</td>
                    </tr>
                    <tr>
                        <td class="time">10h30 :</td>
                        <td>Pause café</td>
                    </tr>
                    <tr>
                        <td class="time">10h40 :</td>
                        <td>La "place du marché" (8 ateliers, 8 thématiques)</td>
                    </tr>
                    <tr>
                        <td class="time">11h50 :</td>
                        <td>Le Permis Tronçonneuse, témoignages vidéo</td>
                    </tr>
                    <tr>
                        <td class="time">12h10 :</td>
                        <td>La "place du marché" : synthèse et conclusions</td>
                    </tr>
                    <tr class="border-bottom border-bottom-lg border-primary">
                        <td class="time">12h40 :</td>
                        <td>Clôture du 1er congrès national du Permis Tronçonneuse</td>
                    </tr>
                    <tr>
                        <td class="time">13h00 :</td>
                        <td>Déjeuner / Buffet</td>
                    </tr>
                </table>
                <div class="d-flex-center mt-auto">
                    <button type="button" @click="openPdf8" class="btn btn-pill btn-outline-primary av85 d-flex align-items-center mb-4">
                        <i class="fa-solid fa-file-pdf mr-3 fa-2x"></i>
                        <div class="d-flex flex-column justify-content-center">
                            <span>Consulter le programme détaillé</span>
                            <span class="fs-sm">(Mercredi 08 février)</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column align-items-center">
            <a href="https://forms.gle/GoLukErHRdyYDvs36" target="_blank" class="btn btn-lg btn-primary btn-inscription mt-5">
                <span>S'inscrire</span>
                <i class="fa-solid fa-arrow-up-right-from-square ml-2"></i>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        openPdf7() {
            window.open("/resources/Programme 07 février.pdf", "_blank");
        },
        openPdf8() {
            window.open("/resources/Programme 08 février.pdf", "_blank");
        },
    },
};
</script>
